import React from 'react';
import * as S from './compose-input.styles';

export interface IComposeInputProps {
    onChange: (subject: string) => void;
    disabled?: boolean;
    isNote?: boolean;
    maxLength?: number;
    subject?: string;
}

export const ComposeInput: React.FunctionComponent<IComposeInputProps> = (
    props: IComposeInputProps,
): React.ReactElement => {
    const { onChange, disabled, isNote, maxLength, subject } = props;
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        onChange(e.target.value);
    };
    return (
        <S.Wrapper disabled={disabled} isNote={isNote}>
            <S.Input
                disabled={disabled}
                placeholder="What's on your mind?"
                value={subject || ''}
                onChange={handleChange}
                maxLength={maxLength || 80}
            />
        </S.Wrapper>
    );
};
